(function(){
  'use strict';
  if(window.__SG_SELLER_FUNNEL_READY__) return;
  window.__SG_SELLER_FUNNEL_READY__ = true;

  var GA_ID = 'G-MEFN90HZPZ';
  var allowedSources = [
    'sell_stone_island',
    'sell_cp_company',
    'stone_island_collection',
    'cp_company_collection',
    'art_checker',
    'homepage',
    'sitewide',
    'paid_search',
    'email',
    'buyback_email',
    'social',
    'seller_guide',
    'direct'
  ];
  var attributionParams = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'gclid',
    'gbraid',
    'wbraid',
    'msclkid'
  ];
  var landingPages = {
    '/pages/sell-stone-island': { brand: 'Stone Island', funnel: 'stone_island', source: 'sell_stone_island', viewEvent: 'sg_sell_stone_island_view' },
    '/pages/sell-cp-company': { brand: 'C.P. Company', funnel: 'cp_company', source: 'sell_cp_company', viewEvent: 'sg_sell_cp_company_view' }
  };

  function analyticsDisabled(){
    return !!window.__SG_CONFIRMED_ANALYTICS_BOT__ || !!window['ga-disable-' + GA_ID];
  }

  function normaliseSource(value){
    var source = String(value || '').toLowerCase().replace(/[^a-z0-9_]/g, '');
    return allowedSources.indexOf(source) > -1 ? source : 'direct';
  }

  function pathName(){
    return window.location.pathname.replace(/\/+$/, '') || '/';
  }

  function currentParam(name){
    try { return String(new URL(window.location.href).searchParams.get(name) || ''); }
    catch(e){ return ''; }
  }

  function currentSource(){
    var explicit = currentParam('source');
    if(explicit) return normaliseSource(explicit);

    var medium = currentParam('utm_medium').toLowerCase();
    if(currentParam('gclid') || currentParam('gbraid') || currentParam('wbraid') || currentParam('msclkid') || /(cpc|ppc|paid|paid_search|paidsearch)/.test(medium)) return 'paid_search';
    if(/email/.test(medium)) return 'email';
    if(/social/.test(medium)) return 'social';
    return 'direct';
  }

  function copyAttribution(target){
    attributionParams.forEach(function(name){
      var value = currentParam(name);
      if(value && !target.searchParams.get(name)) target.searchParams.set(name, value);
    });
  }

  function sourceBrand(source){
    source = normaliseSource(source);
    if(source === 'sell_cp_company' || source === 'cp_company_collection') return 'C.P. Company';
    if(source === 'sell_stone_island' || source === 'stone_island_collection' || source === 'art_checker') return 'Stone Island';
    return '';
  }

  function currentBrand(){
    var config = landingPages[pathName()];
    if(config) return config.brand;
    var brand = currentParam('brand');
    if(brand === 'Stone Island' || brand === 'C.P. Company') return brand;
    return sourceBrand(currentSource());
  }

  function funnelSlug(brand){
    if(brand === 'C.P. Company') return 'cp_company';
    if(brand === 'Stone Island') return 'stone_island';
    return 'sell_to_us';
  }

  function brandForLink(link){
    try {
      var target = new URL(link.href, window.location.origin);
      var config = landingPages[target.pathname.replace(/\/+$/, '') || '/'];
      if(config) return config.brand;
      var brand = String(target.searchParams.get('brand') || '');
      if(brand === 'Stone Island' || brand === 'C.P. Company') return brand;
    } catch(e) {}
    return sourceBrand(link.getAttribute('data-sg-seller-source') || '');
  }

  function sendEvent(name, params){
    if(analyticsDisabled()) return;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function(){ window.dataLayer.push(arguments); };
    var explicitBrand = params && params.seller_brand ? params.seller_brand : '';
    var brand = explicitBrand || currentBrand();
    var payload = {
      seller_funnel: funnelSlug(brand),
      seller_brand: brand || 'Unspecified',
      seller_source: currentSource(),
      utm_source: currentParam('utm_source') || undefined,
      utm_medium: currentParam('utm_medium') || undefined,
      utm_campaign: currentParam('utm_campaign') || undefined,
      utm_term: currentParam('utm_term') || undefined,
      gclid_present: currentParam('gclid') ? 'yes' : 'no'
    };
    Object.keys(params || {}).forEach(function(key){ payload[key] = params[key]; });
    window.gtag('event', name, payload);
  }

  function runOnce(element, key, callback){
    if(!element || element.dataset[key] === '1') return;
    element.dataset[key] = '1';
    callback();
  }

  function selectedPayout(form){
    var input = form.querySelector('input[name="payout_preference"]:checked');
    return input ? String(input.value || '') : '';
  }

  function itemCountBand(form){
    var input = form.querySelector('[name="item_count_band"]');
    return input ? String(input.value || '') : '';
  }

  function ensureHidden(form, name, value){
    var input = form.querySelector('input[name="' + name + '"]');
    if(!input){
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value || '';
  }

  function init(){
    var path = pathName();
    var landing = landingPages[path];

    if(landing){
      runOnce(document.documentElement, 'sgSellerLandingView', function(){
        sendEvent('sg_sell_landing_view', { seller_brand: landing.brand, page_path: path });
        sendEvent(landing.viewEvent, { seller_brand: landing.brand, page_path: path });
      });
    }

    document.addEventListener('click', function(event){
      var link = event.target.closest && event.target.closest('[data-sg-seller-cta]');
      if(!link) return;

      var source = normaliseSource(link.getAttribute('data-sg-seller-source') || currentSource());
      var brand = brandForLink(link) || currentBrand();

      if(landing){
        var origin = currentSource();
        source = origin !== 'direct' ? origin : landing.source;
        brand = landing.brand;

        try {
          var href = link.getAttribute('href') || '';
          if(href.indexOf('/pages/sell-to-us') > -1){
            var target = new URL(link.href, window.location.origin);
            target.searchParams.set('source', source);
            if(!target.searchParams.get('brand')) target.searchParams.set('brand', landing.brand);
            var art = currentParam('art');
            if(art && !target.searchParams.get('art')) target.searchParams.set('art', art);
            var order = currentParam('order');
            if(order && !target.searchParams.get('order')) target.searchParams.set('order', order);
            copyAttribution(target);
            link.href = target.pathname + target.search + target.hash;
          }
        } catch(e) {}
      }

      var clickPayload = { seller_source: source, seller_brand: brand, page_path: path };
      sendEvent('sg_sell_cta_click', clickPayload);
      if(brand === 'Stone Island') sendEvent('sg_sell_stone_island_cta_click', clickPayload);
      if(brand === 'C.P. Company') sendEvent('sg_sell_cp_company_cta_click', clickPayload);
    });

    if(path !== '/pages/sell-to-us') return;

    var form = document.querySelector('.sg-sell__form');
    if(!form) return;

    var requestedBrand = currentParam('brand');
    if(requestedBrand === 'Stone Island' || requestedBrand === 'C.P. Company'){
      var brandField = form.querySelector('[data-field="brand"]');
      if(brandField && !brandField.value){
        brandField.value = requestedBrand;
        brandField.dispatchEvent(new Event('input', { bubbles: true }));
        brandField.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    var requestedArt = currentParam('art');
    if(requestedArt){
      var artField = form.querySelector('[data-field="art_code"]');
      if(artField && !artField.value){
        artField.value = requestedArt;
        artField.dispatchEvent(new Event('input', { bubbles: true }));
        artField.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    var requestedOrder = currentParam('order');
    if(requestedOrder){
      var orderField = form.querySelector('[name="buyback_order_name"]');
      if(orderField && !orderField.value){
        orderField.value = requestedOrder;
        orderField.dispatchEvent(new Event('input', { bubbles: true }));
        orderField.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    var sourcePage = form.querySelector('input[name="source_page"]');
    if(sourcePage) sourcePage.value = window.location.href;
    ensureHidden(form, 'seller_source', currentSource());
    ensureHidden(form, 'seller_brand', currentBrand());
    ensureHidden(form, 'seller_art_reference', requestedArt);
    attributionParams.forEach(function(name){
      ensureHidden(form, name, currentParam(name));
    });

    runOnce(form, 'sgSellerFormView', function(){
      sendEvent('sg_sell_form_view', { page_path: path });
    });

    var markStart = function(){
      runOnce(form, 'sgSellerFormStart', function(){
        sendEvent('sg_sell_form_start', { page_path: path });
      });
    };

    form.addEventListener('input', markStart, { passive: true });
    form.addEventListener('change', markStart, { passive: true });

    form.querySelectorAll('input[name="payout_preference"]').forEach(function(input){
      input.addEventListener('change', function(){
        sendEvent('sg_sell_payout_preference', {
          page_path: path,
          payout_preference: selectedPayout(form)
        });
      });
    });

    form.addEventListener('submit', function(){
      if(typeof form.checkValidity === 'function' && !form.checkValidity()) return;
      sendEvent('sg_sell_submit_attempt', {
        page_path: path,
        payout_preference: selectedPayout(form),
        item_count_band: itemCountBand(form),
        has_art_reference: requestedArt ? 'yes' : 'no',
        buyback_prefilled: requestedOrder ? 'yes' : 'no'
      });
    }, true);

    var observer = new MutationObserver(function(){
      var success = form.querySelector('.sg-sell__status--success');
      if(!success) return;
      runOnce(form, 'sgSellerSubmitSuccess', function(){
        sendEvent('sg_sell_submit_success', {
          page_path: path,
          payout_preference: selectedPayout(form),
          item_count_band: itemCountBand(form),
          has_art_reference: requestedArt ? 'yes' : 'no',
          buyback_prefilled: requestedOrder ? 'yes' : 'no'
        });
      });
    });

    observer.observe(form, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'hidden']
    });
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
